/**
 * Formats an ISO timestamp as relative time, e.g. "10 mins ago", "4 hrs ago".
 */
export function formatTimeAgo(iso: string, nowMs = Date.now()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';

  const diffSec = Math.max(0, Math.floor((nowMs - then) / 1000));

  if (diffSec < 60) return 'just now';

  const mins = Math.floor(diffSec / 60);
  if (mins < 60) return mins === 1 ? '1 min ago' : `${mins} mins ago`;

  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return hrs === 1 ? '1 hr ago' : `${hrs} hrs ago`;

  const days = Math.floor(hrs / 24);
  if (days < 7) return days === 1 ? '1 day ago' : `${days} days ago`;

  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
